import {SYSTEM_SANS} from "../../common/newFontPicker/fonts";

export const SERIF_STACK = "'Iowan Old Style', 'Palatino Linotype', Palatino, Georgia, 'Noto Serif', 'Times New Roman', serif";

export interface SigningFonts {
    body: string;
    heading: string;
    classic: boolean;
}

export const signingFonts = (fontFamily?: string): SigningFonts => {
    const family = fontFamily?.trim();
    return family
        ? {body: family, heading: family, classic: false}
        : {body: SYSTEM_SANS, heading: SERIF_STACK, classic: true};
};
